module.exports = __webpack_public_path__ + "static/media/дом жанетт.91d4b7dc.jpg";